export default __webpack_public_path__ + "static/media/head03_ko_pc@2x.4f723226.png";